<head>

<script src="https://unpkg.com/vue"></script>
<script src="https://unpkg.com/vue-cal"></script>
<link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">
</head>
<template>
  <br />
  <div class="row" style="margin-bottom: 10px">
    <span class="page-title">Visualizar Agenda</span>
  </div>

  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-4">
      <label for="cpf">CPF</label>
      <input type="text" class="form-control form-input-component" v-mask="'###.###.###-##'" ref="cpf" v-model="dataUser.cpf" id="cpf" readonly disabled />
    </div>

    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-4">
      <label for="nome">Nome</label>
      <input type="text" class="form-control form-input-component" v-model="dataUser.nome" id="nome" readonly disabled />
    </div>

    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
      <label>Especialidade</label>
      <input type="text" class="form-control form-input-component" v-model="profissional.especialidade.nome" readonly disabled />
    </div>
  </div>
  <br />
  <br />

  <div style="height: max-content">
    <vue-cal class="vuecal--full-height-delete vuecal--blue-theme" click-to-navigate locale="pt-br" hide-view-selector :time-from="6 * 60" :timeTo="20 * 60" :disable-views="['years', 'year', 'month', 'day']" :hide-weekdays="[]" :editable-events="{ title: false, create: false, delete: false, resize: false, drag: false }" :resizeX="true" :snapToTime="60" :dragToCreateEvent="true" :minDate="new Date()" :events="listaAgenda" @view-change="viewChange($event)" :on-event-click="onEventClick" :min-event-width="50" />
  </div>
</template>

<script>
import { getDataUser } from '@/utils';
import { removeMascaraCpf, weekYear } from '@/utils/servicos-utils';
import { getProfissionalByCpf } from '@/components/service/profissionalService';
import { openNotification, typesNotification } from '@/utils/notifications';
import { getAllEvents } from '@/components/service/agenda';
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import { getByIdAgendamento } from '@/components/service/agendamento-medico';
import { createRegistroAtendimento, getByIdAgendamentoMedico } from '@/components/service/registroAtendimentoService';

export default {
  components: { VueCal },
  name: 'PageVisualizarAgenda',
  data() {
    return {
      listaAgenda: [],
      dataUser: getDataUser(),
      profissional: { especialidade: { nome: undefined } },
    };
  },
  methods: {
    viewChange(events) {
      this.carregarCalendario(events.week);
    },
    carregarCalendario(numSemana) {
      let cpf = removeMascaraCpf(this.dataUser.cpf);
      //console.log(cpf);
      getAllEvents(cpf, numSemana)
        .then((r) => {
          this.listaAgenda = r.data;
          this.listaAgenda.forEach((item) => {
            if (item.type === 'BLOQUEIO') {
              item.class = 'evento-bloqueado';
            } else {
              item.class = 'evento-alocado';
            }
          });
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao recuperar a lista de eventos da agenda!');
        });
    },
    recuperarProfissionalLogado() {
      getProfissionalByCpf(this.dataUser.cpf)
        .then((r) => {
          console.log(r.data);
          this.profissional = r.data;
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Usuário não cadastrado como Profissional de Saúde!');
        });
    },
    onEventClick(event) {
      console.log(event);
      if (event.type != 'CONSULTA') {
        openNotification(typesNotification.error, 'Evento Não Editável');
        return;
      }
      this.confirmacaoInicioConsulta(event);
    },
    confirmacaoInicioConsulta(event) {
      this.$swal({
        title: 'Deseja Iniciar o Atendimento?',
        icon: 'warning',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Sim!',
        cancelButtonText: 'Não!',
      }).then((result) => {
        if (result.isConfirmed) {
          this.novoAgendamento(event.id);
        }
      });
    },
    async novoAgendamento(id) {
      await getByIdAgendamentoMedico(id).then((r) => {
        if (r.data.id) {
          this.$router.push({ path: '/acompanhamento-paciente', query: { id: r.data.id } });
        } else {
          this.criarAtendimento(id);
        }
      });
    },
    async criarAtendimento(id) {
      await getByIdAgendamento(id).then(async (ra) => {
        await createRegistroAtendimento({ agendamentoMedico: ra.data }).then((r) => {
          this.$router.push({ path: '/acompanhamento-paciente', query: { id: r.data.id } });
        });
      });
    },
  },
  created() {
    this.recuperarProfissionalLogado();
    this.carregarCalendario(weekYear());
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}

.evento-alocado {
  background-color: #a4e6d2e6;
  border: 1px solid rgb(144, 210, 190);
  color: #666;
}

.evento-bloqueado {
  background-color: #ff6666d9;
  border: 1px solid rgb(235, 82, 82);
  color: #fff;
}
</style>
